import React from 'react'
export default function Payment() {
    return (
        <div className={`globalcenter pb-5`}>
            <h1 className='mb-5'>Payment Methods</h1>
            <hr />
            <h4> Credit / Debit Cards</h4>
            <h4>PAYPAL</h4>
            <h4>Offline Payments</h4>
        </div>
    )
}
